import React, { useState, useEffect } from 'react'
import Navbar from '../Comman_Layout/Header/Navbar'
import Footer from '../Comman_Layout/Footer/Footer'
import Gotop from '../Comman_Layout/Gotop'
import ServiceBanner from './ServiceBanner'
import ServicesArea from './ServicesArea'
import { Helmet } from 'react-helmet-async'
import { useSelector, useDispatch } from "react-redux";
import { getServicesPageMetaData } from '../../Redux/action/Homeaction';
const Services = () => {
    const dispatch = useDispatch();
    const [isLoading, setisLoading] = useState(false);
    useEffect(() => {
        setisLoading(false);
        dispatch(getServicesPageMetaData());
        setisLoading(true);
    }, []);
    const servicespagemetadataDetail = useSelector((state) => state.HomeReducer ? state.HomeReducer.servicespagemetadataList.data : "");
    // console.log('Services page meta data =', servicespagemetadataDetail);
    return (
        <>
            {
                isLoading && <Helmet>
                    <title> {servicespagemetadataDetail?`${servicespagemetadataDetail.metatag}`:`Best IT services provider in India | Alobha technologies`} </title>
                    <meta name="description" content={servicespagemetadataDetail?`${servicespagemetadataDetail.metadescription}`:""} />
                    <meta name="keywords" content={servicespagemetadataDetail?`${servicespagemetadataDetail.keyword}`:""} />
                </Helmet>
            }
            <Navbar />
            <ServiceBanner />
            <ServicesArea />
            <Footer />
            <Gotop />
        </>
    )
}

export default Services